// extracted by mini-css-extract-plugin
export default {"normalCase":"RootsTechBannerTextStyles_normalCase__lq4sL","magentaGradient":"RootsTechBannerTextStyles_magentaGradient__E0Izz","boldFont":"RootsTechBannerTextStyles_boldFont__oaYjw"};